<template lang="pug">
.vue-time-entries-header.page-header-wrapper.row.align-items-center
  .col-lg-4.col-sm-3
    h2.page-heading.m-0 View &amp; edit timesheets
  .col-lg-4.col-sm-6.text-center
    .toggle-multiple-options.m-0(data-toggle="buttons")
      label.btn.btn-toggle-option.view-toggle(
        :class="{ active: daily }"
        @click="updateTab('daily')"
      )
        | Daily
      label.btn.btn-toggle-option.view-toggle(
        :class="{ active: weekly }"
        @click="updateTab('weekly')"
      )
        | Weekly
      label.btn.btn-toggle-option.view-toggle(
        :class="{ active: calendar }"
        @click="updateTab('calendar')"
      )
        | Calendar
  .col-lg-4.col-sm-3
    .settings-link-wrapper(v-if="permittedToManageSettings")
      a.settings-link(
        v-if="organization"
        :href="`/organizations/${organization.id}/settings/timesheets`"
      )
        i.hi.hi-settings
        |
        | Settings
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesHeader',
  props: {
    selectedTab: {
      type: String,
      default: 'daily',
    },
  },
  computed: {
    ...mapGetters(['permittedToManageSettings', 'organization']),
    calendar() {
      return this.selectedTab === 'calendar';
    },
    daily() {
      return this.selectedTab === 'daily';
    },
    weekly() {
      return this.selectedTab === 'weekly';
    },
  },
  methods: {
    updateTab(tabId) {
      this.$emit('change', tabId);
    },
  },
};
</script>
